import { render, staticRenderFns } from "./CurrencyRates.vue?vue&type=template&id=69d60daa"
import script from "./CurrencyRates.js?vue&type=script&lang=js&external"
export * from "./CurrencyRates.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports